import { render } from "./ViewedProducts.vue?vue&type=template&id=4adfe9f0"
import script from "./ViewedProducts.vue?vue&type=script&lang=ts"
export * from "./ViewedProducts.vue?vue&type=script&lang=ts"
script.render = render

export default script